import { render } from "./DiscoverMyData.vue?vue&type=template&id=15f30475&scoped=true"
import script from "./DiscoverMyData.vue?vue&type=script&lang=js"
export * from "./DiscoverMyData.vue?vue&type=script&lang=js"

import "./DiscoverMyData.vue?vue&type=style&index=0&id=15f30475&lang=scss&scoped=true"
import "./DiscoverMyData.vue?vue&type=style&index=1&id=15f30475&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f30475"]])

export default __exports__